var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D41245",
    fillRule: "nonzero",
    d: "M9.902 7.5l5.704-5.348a1.206 1.206 0 0 0 0-1.783 1.409 1.409 0 0 0-1.901 0L8 5.717 2.295.37a1.409 1.409 0 0 0-1.901 0 1.206 1.206 0 0 0 0 1.783L6.098 7.5.394 12.848a1.206 1.206 0 0 0 0 1.783 1.409 1.409 0 0 0 1.901 0L8 9.283l5.705 5.348a1.409 1.409 0 0 0 1.901 0 1.206 1.206 0 0 0 0-1.783L9.902 7.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape);
export default __webpack_public_path__ + "static/media/shape.1af0fdc782007c565889940244052555.svg";
export { ForwardRef as ReactComponent };